<template>
  <div class="bg-white border-gray-200">
    <div
      class="flex items-center gap-2 cursor-pointer ml-6"
      @click="!disabled ? emit('change', permission) : null"
      :class="{
        '!cursor-default': disabled,
      }"
    >
      <input
        :checked="checked"
        type="checkbox"
        class="h-4 w-4 rounded-xs border-gray-300 text-brand-900 focus:ring-0 focus:outline-0 focus:ring-offset-0 cursor-pointer enabled:hover:opacity-80"
        :class="{
          '!cursor-not-allowed ': disabled,
        }"
        :disabled="disabled"
        @click.stop="emit('change', permission)"
      />
      <p class="text-sm m-0 text-gray-700 enabled:hover:opacity-80">
        {{ t(`permissions.${permission.name}`) }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";

defineProps({
  permission: {
    type: Object,
    required: true,
  },
  checked: {
    type: Boolean,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const emit = defineEmits(["change"]);
</script>
